//This component handle slider for grades / need to Refactor this code
import React from "react";
import reqwest from "reqwest";
import { Slider, Card, Select, Button, Row, Col,Popover,Tooltip } from "antd";
import { connect } from "react-redux";
import { activateDatadic,activateDatadicbackup,activateFiname,activateChange,activateScreen,activateRecord,activatePath,activateGoing,  activateUnivid,
  activateUnivtype, } from "../redux";
import { CloseCircleTwoTone, PoweroffOutlined } from "@ant-design/icons";

const { Option } = Select;

class Sliderbubclass extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      filtermt:this.props.filtermt,
      pass: this.props.pass,
      setp: [],
      id: this.props.id,
      data: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.renderGr = this.renderGr.bind(this);
  }

  componentDidMount() {
    this.ReveGrade();
  }

  alphanum_range = (function () {
    var data = ["A", "B", "C", "D", "F", "NA"];
    return function (start, stop) {
      // console.log('startstop',start+'-'+stop)
      start = data.indexOf(start);
      stop = data.indexOf(stop);
      return !~start || !~stop ? null : data.slice(start, stop + 1);
    };
  })();

  setsGrade(e, i) {
    console.log("SSSSSSSSSSSSSSSS", e + "------" + i);
    return this.alphanum_range(e, i);
  }

  renderGr() {
    if (this.props.pass.value != "") {
      var g1;
      var g2;
      if (this.props.pass.value[0] == "A") {
        g1 = 1;
      }
      if (this.props.pass.value[0] == "B") {
        g1 = 2;
      }
      if (this.props.pass.value[0] == "C") {
        g1 = 3;
      }
      if (this.props.pass.value[0] == "D") {
        g1 = 4;
      }
      if (this.props.pass.value[0] == "F") {
        g1 = 5;
      }
      if (this.props.pass.value[0] == "NA") {
        g1 = 6;
      }

      if (this.props.pass.value[1] == "A") {
        g2 = 1;
      }
      if (this.props.pass.value[1] == "B") {
        g2 = 2;
      }
      if (this.props.pass.value[1] == "C") {
        g2 = 3;
      }
      if (this.props.pass.value[1] == "D") {
        g2 = 4;
      }
      if (this.props.pass.value[1] == "F") {
        g2 = 5;
      }
      if (this.props.pass.value[1] == "NA") {
        g2 = 6;
      }

      return [g1, g2];
    }
  }
  ReveGrade() {
    if (this.props.pass.value != "") {
      var g1;
      var g2;
      if (this.props.pass.value[0] == "A") {
        g1 = 1;
      }
      if (this.props.pass.value[0] == "B") {
        g1 = 2;
      }
      if (this.props.pass.value[0] == "C") {
        g1 = 3;
      }
      if (this.props.pass.value[0] == "D") {
        g1 = 4;
      }
      if (this.props.pass.value[0] == "F") {
        g1 = 5;
      }
      if (this.props.pass.value[0] == "NA") {
        g1 = 6;
      }

      if (this.props.pass.value[1] == "A") {
        g2 = 1;
      }
      if (this.props.pass.value[1] == "B") {
        g2 = 2;
      }
      if (this.props.pass.value[1] == "C") {
        g2 = 3;
      }
      if (this.props.pass.value[1] == "D") {
        g2 = 4;
      }
      if (this.props.pass.value[1] == "F") {
        g2 = 5;
      }
      if (this.props.pass.value[1] == "NA") {
        g2 = 6;
      }

      this.setState({
        setp: [g1, g2],
      });
    }
  }

  removeElement(array, elem) {
    var index = array.indexOf(elem);
    while (index > -1) {
      array.splice(index, 1);
      index = array.indexOf(elem);
    }
    return array;
  }

  ReveGradeAgain(e) {
    var a = 0;
    var b = 0;
    var c = 0;
    var d = 0;
    var f = 0;
    var na = 0;

    var arr = [];
    if (this.props.pass.value.includes("A")) {
      a = 1;
    }
    if (this.props.pass.value.includes("B")) {
      b = 2;
    }
    if (this.props.pass.value.includes("C")) {
      c = 3;
    }
    if (this.props.pass.value.includes("D")) {
      d = 4;
    }
    if (this.props.pass.value.includes("F")) {
      f = 5;
    }
    if (this.props.pass.value.includes("NA")) {
      na = 6;
    }

    var gg = [a, b, c, d, f, na].sort();

    gg = this.removeElement(gg, 0);

    let fa = gg[0];
    // storing the last item
    let la = gg[gg.length - 1];
    console.log("LOADDDDDDDDDDDD", fa + "---" + la);

    return [fa, la];
  }

  handleChange(e) {
    this.props.activateChange(1);
    var ps = [];
    var ns = [];
    if (e[0] == 1) {
      ps = "A";
    }

    if (e[1] == 1) {
      ns = "A";
    }

    if (e[0] == 2) {
      ps = "B";
    }

    if (e[1] == 2) {
      ns = "B";
    }

    if (e[0] == 3) {
      ps = "C";
    }

    if (e[1] == 3) {
      ns = "C";
    }

    if (e[0] == 4) {
      ps = "D";
    }

    if (e[1] == 4) {
      ns = "D";
    }

    if (e[0] == 5) {
      ps = "F";
    }

    if (e[1] == 5) {
      ns = "F";
    }

    if (e[0] == 6) {
      ps = "NA";
    }

    if (e[1] == 6) {
      ns = "NA";
    }

    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].value = e;
    this.props.datadic.FilterDic.columns[
      this.myRef.current.props.id
    ].selected = 1;

    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].sqlValue =
      this.setsGrade(ps, ns);
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].value =
      this.setsGrade(ps, ns);
       setTimeout(() =>  this.HandleReqcount(), 1*1000);
    //this.ReveGrade();
  }

  enterClose(e) {
    this.props.activateChange(1);
    if (this.state.filtermt==0){
   
       this.props.activateFiname('');
       this.props.activateChange('');
 
     }
    this.props.datadic.FilterDic.columns[
      this.myRef.current.props.id
    ].selected = 0;
    this.props.datadic.FilterDic.columns[
      this.myRef.current.props.id
    ].selectedUI = 0;
    this.props.datadic.FilterDic.columns[
      this.myRef.current.props.id
    ].value = '';
  
    this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
    console.log('running 2',this.state.filtermt)
     setTimeout(() =>  this.HandleReqcount(), 1*1000);
  }




  onDataUpdate = (data) => {
    this.setState(
      {
       
        lookingTickers: false,
      }   )
        this.props.activateRecord(data);
        
        this.props.activateScreen(false);
        this.props.activateGoing(false);
        
    
   
  }
  HandleReqcount() {
   
    this.props.activateScreen(true);
    
    const controller = new AbortController();
    
    const { signal } = controller;
    
   if (this.props.going==false) {
    
    var  requestOptions= '';
    this.props.activateScreen(true);
    if (this.props.univtype==1) {
    
       requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  portfolioId : this.props.univid   }),
     };
   
    }
    
    if (this.props.univtype==2) {
       requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  screenId : this.props.univid   }),
     };
   }
 
   if (this.props.univtype==0) {
     requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic]    }),
     };
   }


    this.props.activateGoing(true);
    fetch(
      this.props.apppath + "/include/api/screener/ssfiltercount.cfm", 
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
       this.onDataUpdate(data)
       
      )
      .then((data) => 1)
      .catch((error) => {
         
        this.props.activateScreen(false);
        this.props.activateGoing(false);
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
          }
        );
      });
    }else{
     
     console.log(this.props.going)
    }
  }


  render() {
    const marks = {
      1: "A",
      2: "B",
      3: "C",
      4: "D",
      5: "F",
      6: "NA",
    };

    const slidestyle = {
      width: "100%",
    };

    const closebutton = {
      float: "right",
    };
    const gridStyle = {
      //  float: "right",
      width: '100%',
   
        
      };
    return (
      <div>
        <Card>
        <Card.Grid style={gridStyle} className='movercard'>
        <Popover content={this.state.pass.definition} title={this.state.pass.label} placement="right">
          {this.state.pass.label}
       </Popover>
          <Row className="rw" >
            {" "}
            <Col span={20}>
              {" "}
              <Slider
                defaultValue={
                  this.props.pass.value != ""
                    ? this.ReveGradeAgain(this.props.pass.value)
                    : [1, 6]
                }
                range={{ draggableTrack: true }}
                ref={this.myRef}
                id={this.state.id}
                tooltipVisible={false}
                onChange={this.handleChange}
                marks={marks}
                dots={true}
                max={6}
                min={1}
              ></Slider>{" "}
            </Col>
            <Col span={2} style={{paddingRight:'18px'}}>
              {" "}
              &nbsp; &nbsp; &nbsp;{" "}
              <div style={closebutton}>
                {" "}
                <Tooltip placement="topLeft" title="Remove this filter" color={'#2db7f5'}>
                <Button
                  type="text"
                  icon={<CloseCircleTwoTone />}
                  onClick={() => this.enterClose(this.state.id)}
                ></Button> </Tooltip>{" "}
              </div>{" "}
            </Col>
          </Row>
          </Card.Grid>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  datadic: state.datadic,
  datadicbackup: state.datadicbackup,
  finame: state.finame,
  change: state.change,
  screen: state.screen,
  record: state.record,
  apppath: state.apppath,
  going: state.going,
  univid: state.univid,
  univtype: state.univtype,
});

const mapDispatchToProps = {
  activateDatadic,activateDatadicbackup,activateFiname,activateChange,activateScreen,activateRecord,activatePath, activateGoing,  activateUnivid,
  activateUnivtype,
};

const Sliderbub = connect(mapStateToProps, mapDispatchToProps)(Sliderbubclass);

export default Sliderbub;
